// ABOUTME: Custom TipTap extension for font sizes matching Heading/Subheading.
// ABOUTME: Sizes: heading (21px), subheading (17px), normal (13px).

import { Extension } from "@tiptap/core";

export const FONT_SIZES = {
    heading: "21px",
    subheading: "17px",
    normal: "13px",
};

const FontSize = Extension.create({
    name: "fontSize",

    addOptions() {
        return {
            types: ["textStyle"],
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => element.style.fontSize?.replace("px", "") ? element.style.fontSize : null,
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize || attributes.fontSize === "normal") return {};
                            const size = FONT_SIZES[attributes.fontSize] || attributes.fontSize;
                            return { style: `font-size: ${size}` };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontSize: (size) => ({ chain }) => chain().setMark("textStyle", { fontSize: size }).run(),
            unsetFontSize: () => ({ chain }) => chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run(),
        };
    },
});

export default FontSize;
